<template>
    <transition name="el-zoom-in-top">
        <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <section class="content-header">
            <h1>Chat App<small><i class="ti-heart"></i><i class="ti-export"></i><i class="ti-printer"></i></small></h1>
            <ol class="breadcrumb">
                <li><router-link to="/"> <i class="ti-home"></i></router-link></li>
                <li><a href="#">Apps</a></li>
                <li class="active">Chat App</li>
            </ol>
        </section>
            
            <!-- Main content -->
            <section class="content">
                <div class="container-chat clearfix">
                    <div class="people-list" id="people-list">
                        <div class="search">
                            <input type="text" placeholder="search" /> <i class="fa fa-search"></i> </div>
                        <ul class="list">
                            <li class="clearfix"> <img src="http://api.randomuser.me/portraits/men/22.jpg" alt="avatar" />
                                <div class="about">
                                    <div class="name">Vincent Porter</div>
                                    <div class="status"> <i class="fa fa-circle online"></i> online </div>
                                </div>
                            </li>
                            <li class="clearfix"> <img src="http://api.randomuser.me/portraits/men/23.jpg" alt="avatar" />
                                <div class="about">
                                    <div class="name">Aiden Chavez</div>
                                    <div class="status"> <i class="fa fa-circle offline"></i> left 7 mins ago </div>
                                </div>
                            </li>
                            <li class="clearfix"> <img src="http://api.randomuser.me/portraits/men/24.jpg" alt="avatar" />
                                <div class="about">
                                    <div class="name">Mike Thomas</div>
                                    <div class="status"> <i class="fa fa-circle online"></i> online </div>
                                </div>
                            </li>
                            <li class="clearfix"> <img src="http://api.randomuser.me/portraits/women/25.jpg" alt="avatar" />
                                <div class="about">
                                    <div class="name">Erica Hughes</div>
                                    <div class="status"> <i class="fa fa-circle online"></i> online </div>
                                </div>
                            </li>
                            <li class="clearfix"> <img src="http://api.randomuser.me/portraits/women/26.jpg" alt="avatar" />
                                <div class="about">
                                    <div class="name">Ginger Johnston</div>
                                    <div class="status"> <i class="fa fa-circle online"></i> online </div>
                                </div>
                            </li>
                            <li class="clearfix"> <img src="http://api.randomuser.me/portraits/women/27.jpg" alt="avatar" />
                                <div class="about">
                                    <div class="name">Tracy Carpenter</div>
                                    <div class="status"> <i class="fa fa-circle offline"></i> left 30 mins ago </div>
                                </div>
                            </li>
                            <li class="clearfix"> <img src="http://api.randomuser.me/portraits/men/28.jpg" alt="avatar" />
                                <div class="about">
                                    <div class="name">Christian Kelly</div>
                                    <div class="status"> <i class="fa fa-circle offline"></i> left 10 hours ago </div>
                                </div>
                            </li>
                            <li class="clearfix"> <img src="http://api.randomuser.me/portraits/women/29.jpg" alt="avatar" />
                                <div class="about">
                                    <div class="name">Monica Ward</div>
                                    <div class="status"> <i class="fa fa-circle online"></i> online </div>
                                </div>
                            </li>
                            <li class="clearfix"> <img src="http://api.randomuser.me/portraits/men/30.jpg" alt="avatar" />
                                <div class="about">
                                    <div class="name">Dean Henry</div>
                                    <div class="status"> <i class="fa fa-circle offline"></i> offline since Oct 28 </div>
                                </div>
                            </li>
                            <li class="clearfix"> <img src="http://api.randomuser.me/portraits/women/31.jpg" alt="avatar" />
                                <div class="about">
                                    <div class="name">Peyton Mckinney</div>
                                    <div class="status"> <i class="fa fa-circle online"></i> online </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="chat">
                        <div class="chat-header clearfix"> <img src="http://api.randomuser.me/portraits/men/32.jpg" alt="avatar" />
                            <div class="chat-about">
                                <div class="chat-with">Chat with Vincent Porter</div>
                                <div class="chat-num-messages">already 1 902 messages</div>
                            </div> <i class="fa fa-star"></i> </div>
                        <!-- end chat-header -->
                        <div class="chat-history">
                            <ul>
                                <li class="clearfix">
                                    <div class="message-data align-right"> <span class="message-data-time">10:10 AM, Today</span> &nbsp; &nbsp; <span class="message-data-name">Olia</span> <i class="fa fa-circle me"></i> </div>
                                    <div class="message other-message float-right"> Hi Vincent, how are you? How is the project coming along? </div>
                                </li>
                                <li>
                                    <div class="message-data"> <span class="message-data-name"><i class="fa fa-circle online"></i> Vincent</span> <span class="message-data-time">10:12 AM, Today</span> </div>
                                    <div class="message my-message"> Are we meeting today? Project has been already finished and I have results to show you. </div>
                                </li>
                                <li class="clearfix">
                                    <div class="message-data align-right"> <span class="message-data-time">10:14 AM, Today</span> &nbsp; &nbsp; <span class="message-data-name">Olia</span> <i class="fa fa-circle me"></i> </div>
                                    <div class="message other-message float-right"> Well I am not sure. The rest of the team is not here yet. Maybe in an hour or so? Have you faced any problems at the last phase of the project? </div>
                                </li>
                                <li>
                                    <div class="message-data"> <span class="message-data-name"><i class="fa fa-circle online"></i> Vincent</span> <span class="message-data-time">10:20 AM, Today</span> </div>
                                    <div class="message my-message"> Actually everything was fine. I'm very excited to show this to our team. </div>
                                </li>
                                <li>
                                    <div class="message-data"> <span class="message-data-name"><i class="fa fa-circle online"></i> Vincent</span> <span class="message-data-time">10:31 AM, Today</span> </div> <i class="fa fa-circle online"></i> <i class="fa fa-circle online" style="color: #AED2A6"></i> <i class="fa fa-circle online" style="color:#DAE9DA"></i> </li>
                            </ul>
                        </div>
                        <!-- end chat-history -->
                        <div class="chat-message clearfix">
                            <textarea name="message-to-send" id="message-to-send" placeholder="Type your message" rows="3"></textarea> <i class="fa fa-file-o"></i> &nbsp;&nbsp;&nbsp; <i class="fa fa-file-image-o"></i>
                            <button>Send</button>
                        </div>
                        <!-- end chat-message -->
                    </div>
                    <!-- end chat -->
                </div>
                <!-- end container -->
            </section>
            <!-- /.content -->
        </div>
    </transition>
</template>
<script>
  export default {
    name: 'Chat'
  }
</script>



// WEBPACK FOOTER //
// Chat.vue?34a542af